import { render, staticRenderFns } from "./colorsBar.vue?vue&type=template&id=2c28ab88&scoped=true&"
import script from "./colorsBar.vue?vue&type=script&lang=js&"
export * from "./colorsBar.vue?vue&type=script&lang=js&"
import style0 from "./colorsBar.vue?vue&type=style&index=0&id=2c28ab88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28ab88",
  null
  
)

export default component.exports